
<div class="max-w-md mx-auto mt-12">

  <div *ngIf="requirements?.emailSuffixes?.length" class="mb-6">
    <app-alert type="WARN" *ngIf="user">
      You are signed in as <strong>{{user.email}}</strong>. 
      <br/>
      Please instead sign in or sign up with an email address that ends with
      <app-email-suffixes [suffixes]="requirements!.emailSuffixes"></app-email-suffixes> 

      <p class="text-sm">
        If you signed in with Google and didn't get a chance to choose your account, 
        then please follow <a href="https://www.theverge.com/23610451/chrome-browser-google-accounts-profiles" target="_blank">this guide</a>
        about managing multiple google accounts. 
      </p>
    </app-alert>
    
    <app-alert type="INFO" *ngIf="!user">
      Please use an email address that ends with
      <app-email-suffixes [suffixes]="requirements!.emailSuffixes"></app-email-suffixes>
    </app-alert>
  </div>


  <mat-tab-group color="primary" [selectedIndex]="tabIndex" class="px-6" (selectedIndexChange)="handleTabChange()" [disablePagination]="true">
    <mat-tab label="Sign in" class="mt-6">

      <button class="mt-6 w-full" mat-raised-button color="primary" (click)="signInWithGoogle()">
        Sign in with Google
      </button>

      <p class="my-6 text-center text-muted">
        or
      </p>

      <form #form="ngForm" >
        <div class="grid grid-cols-1 mt-6">
          <mat-form-field color="primary" class="example-full-width">
            <mat-label>Email</mat-label>
            <input matInput type="email" pInputText [(ngModel)]="data.email" name="email" id="email" required/>
          </mat-form-field>

          <mat-form-field color="primary" class="example-full-width">
            <mat-label>Password</mat-label>
            <input matInput type="password" pInputText [(ngModel)]="data.password" name="password" required/>
          </mat-form-field>

          <div *ngIf="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
            {{error}}
          </div>
        </div>
      </form>

      <div class="my-3 flex flex-col">
        <button mat-raised-button color="primary" (click)="signIn()" [disabled]="!canSignIn || loading">
          Sign in
        </button>

        <p class="text-center my-6">
          <a routerLink="/recover-password" >
            I forgot my password
          </a>
        </p>
      </div>

    </mat-tab>

    <mat-tab label="Sign up" >

      <form #form="ngForm" *ngIf="signupStatus == 'SIGNING_UP'">
        <div class="grid grid-cols-1 mt-6">

          <button class="w-full" mat-raised-button color="primary" (click)="signInWithGoogle()">
            Sign up with Google
          </button>

          <p class="my-6 text-center text-muted">
            or
          </p>

          <div class="grid grid-cols-2 gap-6">

            <mat-form-field color="primary" class="example-full-width">
              <mat-label>First name</mat-label>
              <input matInput type="text" [(ngModel)]="data.firstName" name="firstName" required/>
            </mat-form-field>

            <mat-form-field color="primary" class="example-full-width">
              <mat-label>Last name</mat-label>
              <input matInput type="text" [(ngModel)]="data.lastName" name="lastName" required/>
            </mat-form-field>

          </div>

          <mat-form-field color="primary" class="example-full-width">
            <mat-label>Email address</mat-label>
            <input matInput type="email" [(ngModel)]="data.email" name="email" required/>
          </mat-form-field>

          <mat-form-field color="primary" class="example-full-width">
            <mat-label>Password</mat-label>
            <input matInput type="password" [(ngModel)]="data.password" name="password" required/>
          </mat-form-field>

          <mat-form-field color="primary" class="example-full-width">
            <mat-label>Confirm your password</mat-label>
            <input matInput type="password" [(ngModel)]="data.passwordConfirmation" name="passwordConfirmation" required/>
          </mat-form-field>
        </div>

        <div *ngIf="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
          {{error}}
        </div>


        <div class="my-3 flex flex-col">
          <button mat-raised-button color="primary" (click)="signUp()" [disabled]="!canSignUp || loading" >
            Sign up
          </button>
        </div>
      </form>

      <div *ngIf="signupStatus == 'CONFIRMING'">
        <div class="grid grid-cols-1 mt-6">
          <p class="mb-3">
            Please check your email and enter the confirmation code below
          </p>

          <mat-form-field color="primary" class="example-full-width">
            <mat-label>Confirmation Code</mat-label>
            <input matInput type="text" [(ngModel)]="confirmationCode" name="confirmationCode" required/>
          </mat-form-field>

          <div *ngIf="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
            {{error}}
          </div>


          <div class="my-3 flex flex-col ">
            <button mat-raised-button color="primary" (click)="confirmSignUp()">
              Confirm
            </button>

            <p class="text-center mt-6">
              <a (click)="resendConfirmationCode()">Resend code</a>
            </p>

            <p class="text-center mt-6">
              <a class='text-negative' (click)="abortSignup()">Abort signup</a>
            </p>
          </div>
        </div>

      </div>

      <div *ngIf="signupStatus == 'SIGNING_IN'" class="grid grid-cols-1 mt-6 text-center">
        <fa-icon icon="circle-notch" [spin]="true" size="3x"></fa-icon>
      </div>
    </mat-tab>

  </mat-tab-group>

</div>
